<template>
    <b-card no-body class="p-2 border-gray">
        <div class="card-title mb-1">
            {{ $t('Component(Text):information-requested') }}
        </div>
        <div class="pb-2">
            <RequestInformation
                :request="request"
            />
        </div>
        <div>
            <CoveredLegislations :legislations="request.legislations" />
        </div>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import dateRenderer from "@core/mixins/date-renderer";
import RequestInformation from "@/views/request/received/flow/components/vertiacal-steps/RequestInformation.vue";
import CoveredLegislations from "@/views/request/received/flow/components/vertiacal-steps/CoveredLegislations";

export default {
    mixins: [dateRenderer],
    components: {
        BCard, CoveredLegislations, RequestInformation
    },
    props: {
        request: {
            type: Object,
            default() {
                return {
                    legislations: [],
                    verificationDocuments: [],
                    informationLevel: []
                };
            }
        }
    }
}
</script>
